<template>
  <div class="chapter-header">
    <div class="arrowDiv shrink-on-active" v-on:click="prevChapter">
      <inline-svg
        class="arrow-svg-chap"
        v-bind:class="{ disabled: !prev }"
        :src="require(`../../assets/svg/arrow-${ltr ? 'next' : 'back'}.svg`).default"
      ></inline-svg>
    </div>
    <h2>
      {{ title }}
    </h2>
    <div class="arrowDiv shrink-on-active" v-on:click="nextChapter">
      <inline-svg
        class="arrow-svg-chap"
        v-bind:class="{ disabled: !next }"
        :src="require(`../../assets/svg/arrow-${ltr ? 'back' : 'next'}.svg`).default"
      ></inline-svg>
    </div>
    <!-- <ProgressBar
      class="progress-bar-container"
      :progress="progress"
      :max="100"
    /> -->
  </div>
</template>

<script>
import "./chapter-header.scss";
import ProgressBar from "../Shared/progressBar.vue";
export default {
  name: "chapter-header",
  props: ["title", "next", "prev"],
  data() {
    return {
      ltr: localStorage.getItem("srcDirection") == "ltr",
    };
  },

  created() {},
  methods: {
    nextChapter: function(event) {
      if (this.next) {
        this.$router.push({
          path: `/chapter/${this.next}`
        });
      }
    },
    prevChapter: function(event) {
      if (this.prev) {
        this.$router.push({
          path: `/chapter/${this.prev}`
        });
      }
    }
  },
  components: {
    ProgressBar
  }
};
</script>

<style scoped>
.arrow-svg-chap {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// chapter-header.vue?78e3aeee